<template>
    <div class="opacity-60">
        <slot/>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>